import styled from "styled-components";

export const Sekcja = styled.section`
  scroll-margin-top:86px; padding: 90px clamp(16px,5vw,72px); background: #153f1d; color: #fff;
  @media (max-width: 767px) { padding-top: 64px; padding-bottom: 64px; }
`;
export const Inner = styled.div`
  display: grid; grid-template-columns: .85fr 1.15fr; gap: clamp(28px,5vw,68px); align-items: stretch; max-width: 1180px; margin: 0 auto;
  @media (max-width: 860px) { grid-template-columns: 1fr; }
`;
export const Info = styled.div`
  display: flex; flex-direction: column; justify-content: center;
  h2 { margin: 0 0 16px; font-size: clamp(34px,5vw,52px); line-height: 1.04; }
  > p { margin: 0; color: rgba(255,255,255,.76); line-height: 1.6; }
`;
export const Eyebrow = styled.p`margin: 0 0 10px !important; color: ${({ theme }) => theme.color.orange} !important; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase;`;
export const Details = styled.div`display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 12px; margin: 30px 0; @media(max-width:520px){grid-template-columns:1fr;}`;
export const Detail = styled.div`
  display: grid; gap: 6px; padding: 16px; border: 1px solid rgba(255,255,255,.13); border-radius: 16px; background: rgba(255,255,255,.06);
  span { color: rgba(255,255,255,.58); font-size: 12px; text-transform: uppercase; }
  strong { display: grid; gap: 3px; font-size: 14px; line-height: 1.45; }
  a { color: #fff; text-decoration: none; }
`;
export const Actions = styled.div`position:relative;display:flex;flex-wrap:wrap;gap:10px;a{display:inline-flex;align-items:center;min-height:48px;padding:0 20px;border-radius:999px;background:${({theme})=>theme.color.orange};color:${({theme})=>theme.color.black};font-weight:900;text-decoration:none;pointer-events:auto;}a:last-child{border:1px solid rgba(255,255,255,.22);background:transparent;color:#fff;}`;
export const Ramka = styled.iframe`width:100%;min-height:560px;border:0;border-radius:28px;box-shadow:0 25px 65px rgba(0,0,0,.2);@media(max-width:860px){min-height:420px;}`;

